import { useDispatch } from "react-redux";
import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import { useLazyFormHistoryQuery } from "app/services/api/formsApi";
import { format, subDays } from "date-fns";
import { storeFormEntries } from "app/store/slices/formEntries";
import { useCallback } from "react";
import { store } from "app/services/store";
import { FormHistoryResponse } from "app/services/api/types/forms/responses/FormHistoryResponse";
import { BASE_DAYS } from "./constants";

const HISTORY_DATE_FROM_DAYS = BASE_DAYS;

export function usePrefetchFormEntries({ enabled }: OfflinePrefetchProps) {
  const dispatch = useDispatch();
  const [trigger] = useLazyFormHistoryQuery();

  const handlePrefetch = useCallback(async () => {
    const dateFrom = format(
      subDays(new Date(), HISTORY_DATE_FROM_DAYS),
      "yyyy-MM-dd",
    );

    await executePaginatedPrefetch<any, FormHistoryResponse>({
      name: "FormEntries",
      trigger,
      buildQueryArgs: (page) => ({
        filter: {
          date_from: dateFrom,
        },
        limit: 100,
        page,
      }),
      storeData: (data) => dispatch(storeFormEntries(data)),
      getLastPage: (data) => data?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => data?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
